export class CustomError extends Error {
  constructor(
    message: string, // short, human-readable description shown as the error message in Sentry.
    category: string, // assigned to Error.name; Sentry uses it as the issue title to group related errors (e.g. 'AdminCamerasEnabled', 'Reach SDK').
    option?: {
      // the original caught error; preserves the underlying stack/context so the root cause stays visible in Sentry.
      cause?: unknown
    }
  ) {
    super(message, option)
    this.name = category
  }
}
